import React, { Component } from 'react'
import { message, Modal, Form, DatePicker, Popconfirm } from 'antd'
import { getOrderShort, reqOptRecord, reqRecordSave, reqRecordUpdate, reqRecordDel } from '../../api';
import { subTimeStr, subStr } from "../../utills/subStringUtill";
import {
    elhtMala, alskMala, mzlMala,
    elhtDuisburg, mzlDuisburg, alskDuisburg,
    elhtHamburg, alskHamburg, mzlHamburg,
    mzlHs, alskHs,
    mzlWexn, alskWexn, elhtWexn,
    mhWx,
    hegsHegs,
    alskXlyjn, elhtXlyjn, mzlXlyjn,
    alskPlysd, mzlPlysd,
    alskAlktLwgl, elhtAlktLwgl, mzlAlktLwgl,
    alskQpBdps, alskMaLaBdps, mzlBdps
} from "./track-detail"
import './delivery-step.less'
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
}


class DeliveryStep extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: [],
            processShow: false,
            visible: false,
        }
    }

    getOrderShortFunc = async (orderId) => {
        let result = await getOrderShort(orderId)
        if (result.code === 200) {
            this.setState({
                destinationStartCity: result.data.destinationStartCity,
                destinationCity: result.data.destinationCity,
                commitDt: result.data.commitDt,
                exportPort: result.data.exportPort,
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }
    };
    getOptRecord = async (orderId) => {
        const result = await reqOptRecord(orderId);
        if (result.code == '200') {
            //状态：collect:揽货,arrive:到达山口,declare:报关,systemPass:海关系统放行,pass:实货放行,transport:转运,dstkArrive:到达多斯特克,
            //     dstkOut:多斯特克出发,arriveDuisburg:到达目的城市,leaveDuisburg:清关仓库,destination:到达目的地)
            const data = {};
            data.collectDt = this.getDt(result.data, 'collect');
            data.arriveDt = this.getDt(result.data, 'arrive');
            data.declareDt = this.getDt(result.data, 'declare');
            data.systemPassDt = this.getDt(result.data, 'systemPass');
            data.passDt = this.getDt(result.data, 'pass');
            data.transportDt = this.getDt(result.data, 'transport');
            data.dstkArriveDt = this.getDt(result.data, 'dstkArrive');
            data.dstkOutDt = this.getDt(result.data, 'dstkOut');
            data.arriveBrestDt = this.getDt(result.data, 'arriveBrest');
            data.arriveMalaDt = this.getDt(result.data, 'arriveMala');
            data.leaveMalaDt = this.getDt(result.data, 'leaveMala');
            data.destinationDt = this.getDt(result.data, 'destination');
            data.arriveZamynUudDt = this.getDt(result.data, 'arriveZamynUud');
            data.leaveZamynUudDt = this.getDt(result.data, 'leaveZamynUud');
            data.arriveAbaikalDt = this.getDt(result.data, 'arriveAbaikal');
            data.leaveAbaikalDt = this.getDt(result.data, 'leaveAbaikal');
            data.arriveQiaopuDt = this.getDt(result.data, 'arriveQiaopu');
            data.arriveZahonyDt = this.getDt(result.data, 'arriveZahony');
            data.leaveZahonyDt = this.getDt(result.data, 'leaveZahony');
            data.arriveBrestCTDt = this.getDt(result.data, 'arriveBrestCT');
            data.arriveAtenkoriDt = this.getDt(result.data, 'arriveAtenkori');
            data.leaveAtenkoriDt = this.getDt(result.data, 'leaveAtenkori');
            data.arriveBotenDt = this.getDt(result.data, 'arriveBoten');
            data.arriveKartalareDt = this.getDt(result.data, 'arriveKartalare');
            data.arriveAradDt = this.getDt(result.data, 'arriveArad');
            this.setColletDt(data.collectDt)
            this.setState(data);
        }
    };
    getDt = (data, optType) => {
        let record = data.filter(o => o.optType == optType);
        if (record.length > 0) {
            return record[0].optDt
        }
        return '';
    };
    editDate = (type, optDt) => {
        const { action } = this.props;
        if (action === 'edit') {
            if (optDt) {
                this.props.form.setFieldsValue({ optDt: moment(optDt, 'YYYY-MM-DD HH:mm:ss') });
            }
            this.setState({
                visible: true,
                type: type,
                action: optDt ? 'update' : 'add',
            });
        }
    };

    handleOk = async (e) => {
        const { type } = this.state;
        const data = this.props.form.getFieldsValue();
        const values = {};
        values.orderId = this.state.orderId;
        values.optType = type;
        values.optDt = moment(data.optDt).format('YYYY-MM-DD HH:mm:ss');
        if (data.optDt) {
            if (this.state.action == 'update') {
                const result = await reqRecordUpdate(values);
                if (result.code == '200') {
                    this.setDt(type, values.optDt);
                } else {
                    message.error(result.message);
                }
            } else {
                const result = await reqRecordSave(values);
                if (result.code == '201') {
                    this.setDt(type, values.optDt);
                } else {
                    message.error(result.message);
                }
            }
        } else {
            if (this.state.action == 'update') {
                delete values.optDt;
                const result = await reqRecordDel(values);
                if (result.code == '200') {
                    this.setDt(type, values.optDt);
                } else {
                    message.error(result.message);
                }
            }
        }
        this.handleCancel();
    };

    handleCancel = e => {
        this.props.form.resetFields();
        this.setState({
            visible: false,
        });
    };

    setDt = (type, optDt) => {
        if (type === 'collect') {
            this.setState({
                collectDt: optDt,
            });
            this.setColletDt(optDt)
        } else if (type === 'declare') {
            this.setState({
                declareDt: optDt,
            });
        } else if (type === 'systemPass') {
            this.setState({
                systemPassDt: optDt,
            });
        } else if (type === 'arrive') {
            this.setState({
                arriveDt: optDt,
            });
        } else if (type === 'pass') {
            this.setState({
                passDt: optDt,
            });
        } else if (type === 'transport') {
            this.setState({
                transportDt: optDt,
            });
        } else if (type === 'dstkArrive') {
            this.setState({
                dstkArriveDt: optDt,
            });
        } else if (type === 'dstkOut') {
            this.setState({
                dstkOutDt: optDt,
            });
        } else if (type === 'arriveBrest') {
            this.setState({
                arriveBrestDt: optDt,
            });
        } else if (type === 'arriveMala') {
            this.setState({
                arriveMalaDt: optDt,
            });
        } else if (type === 'leaveMala') {
            this.setState({
                leaveMalaDt: optDt,
            });
        } else if (type === 'destination') {
            this.setState({
                destinationDt: optDt,
            });
        } else if (type === 'arriveZamynUud') {
            this.setState({
                arriveZamynUudDt: optDt,
            });
        } else if (type === 'leaveZamynUud') {
            this.setState({
                leaveZamynUudDt: optDt,
            });
        } else if (type === 'arriveAbaikal') {
            this.setState({
                arriveAbaikalDt: optDt,
            });
        } else if (type === 'leaveAbaikal') {
            this.setState({
                leaveAbaikalDt: optDt,
            });
        } else if (type === 'arriveQiaopu') {
            this.setState({
                arriveQiaopuDt: optDt,
            });
        } else if (type === 'arriveZahony') {
            this.setState({
                arriveZahonyDt: optDt,
            });
        } else if (type === 'leaveZahony') {
            this.setState({
                leaveZahonyDt: optDt,
            });
        } else if (type === 'arriveBrestCT') {
            this.setState({
                arriveBrestCTDt: optDt,
            });
        } else if (type === 'arriveAtenkori') {
            this.setState({
                arriveAtenkoriDt: optDt,
            });
        } else if (type === 'leaveAtenkori') {
            this.setState({
                leaveAtenkoriDt: optDt,
            });
        } else if (type === 'arriveBoten') {
            this.setState({
                arriveBotenDt: optDt,
            });
        } else if (type === 'arriveKartalare') {
            this.setState({
                arriveKartalareDt: optDt,
            });
        } else if (type === 'arriveArad') {
            this.setState({
                arriveAradDt: optDt,
            });
        }
    };

    setColletDt = (date) => {
        const { setColletDt } = this.props
        if (setColletDt) {
            setColletDt(date)
        }
    }

    componentDidMount() {
        const orderId = this.props.location.state.orderId;
        this.getOrderShortFunc(orderId);
        this.getOptRecord(orderId);
        this.setState({ orderId: orderId });
    }

    spreadOpt = () => {
        const { processShow } = this.state
        if (processShow) {
            this.setState({
                processShow: false
            })
        } else {
            this.setState({
                processShow: true
            })
        }
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { processShow } = this.state
        const { action } = this.props;
        const destinationCity = this.state.destinationCity;
        const exportPort = this.state.exportPort;
        var cityList = ['汉堡', '杜伊斯堡', '马拉舍维奇', '布达佩斯', '万象', '沃尔西诺', '华沙', '谢利亚季诺', '普洛耶什蒂', '埃列克特罗乌格利（电煤）'];
        var finalCity;
        if (cityList.indexOf(destinationCity) < 0) {
            finalCity = ''
        } else {
            finalCity = destinationCity;
        }
        const ENUM_EXPORT = {
            '马拉舍维奇+阿拉山口': alskMala(this, action, getFieldDecorator, processShow),
            '马拉舍维奇+二连浩特': elhtMala(this, action, getFieldDecorator, processShow),
            '马拉舍维奇+满洲里': mzlMala(this, action, getFieldDecorator, processShow),
            '汉堡+阿拉山口': alskHamburg(this, action, getFieldDecorator, processShow),
            '汉堡+二连浩特': elhtHamburg(this, action, getFieldDecorator, processShow),
            '汉堡+满洲里': mzlHamburg(this, action, getFieldDecorator, processShow),
            '杜伊斯堡+阿拉山口': alskDuisburg(this, action, getFieldDecorator, processShow),
            '杜伊斯堡+二连浩特': elhtDuisburg(this, action, getFieldDecorator, processShow),
            '杜伊斯堡+满洲里': mzlDuisburg(this, action, getFieldDecorator, processShow),
            '布达佩斯+阿拉山口（马拉线）': alskMaLaBdps(this, action, getFieldDecorator, processShow),
            '布达佩斯+阿拉山口（乔普线）': alskQpBdps(this, action, getFieldDecorator, processShow),
            '布达佩斯+满洲里': mzlBdps(this, action, getFieldDecorator, processShow),
            '+霍尔果斯': hegsHegs(this, action, getFieldDecorator, processShow),
            '万象+磨憨': mhWx(this, action, getFieldDecorator, processShow),
            '沃尔西诺+二连浩特': elhtWexn(this, action, getFieldDecorator, processShow),
            '沃尔西诺+阿拉山口': alskWexn(this, action, getFieldDecorator, processShow),
            '沃尔西诺+满洲里': mzlWexn(this, action, getFieldDecorator, processShow),
            '华沙+满洲里': mzlHs(this, action, getFieldDecorator, processShow),
            '华沙+阿拉山口': alskHs(this, action, getFieldDecorator, processShow),
            '谢利亚季诺+阿拉山口': alskXlyjn(this, action, getFieldDecorator, processShow),
            '谢利亚季诺+二连浩特': elhtXlyjn(this, action, getFieldDecorator, processShow),
            '谢利亚季诺+满洲里': mzlXlyjn(this, action, getFieldDecorator, processShow),
            '普洛耶什蒂+阿拉山口': alskPlysd(this, action, getFieldDecorator, processShow),
            '普洛耶什蒂+满洲里': mzlPlysd(this, action, getFieldDecorator, processShow),
            '埃列克特罗乌格利（电煤）+阿拉山口': alskAlktLwgl(this, action, getFieldDecorator, processShow),
            '埃列克特罗乌格利（电煤）+二连浩特': elhtAlktLwgl(this, action, getFieldDecorator, processShow),
            '埃列克特罗乌格利（电煤）+满洲里': mzlAlktLwgl(this, action, getFieldDecorator, processShow)
        };
        let Message = ENUM_EXPORT[finalCity + '+' + exportPort];
        return (
            <div>
                {Message}
            </div>
        )
    }
}
const DeliveryStepForm = Form.create()(DeliveryStep);
export default DeliveryStepForm;